import { createStandaloneToast } from "@chakra-ui/react";
import { getWalletName, SyncState } from "@syla/shared/types/models/WalletBase";
import { secondsToMilliseconds } from "date-fns";
import { errorToToastOptions } from "../../api/errors/errorToToastOptions";
import { reSyncWallet as reSyncWalletRequest } from "../../api/wallet/reSyncWallet";
import { buildSyncErrorToastProps } from "../../helper/wallet/buildSyncErrorToastProps";
import { theme } from "../../theme";
import { checkStatusAndDoPendingWork } from "../pendingWork";
import {
  queryClient,
  getAccountTransactionsCacheKey,
} from "../transactionsStore";
import { getAllAssetsCacheKey } from "../useQueryAssets";
import { buildSyncSuccessToastProps } from "./buildSyncSuccessToastProps";
import { WalletToSync } from "./syncWallet";
import { updateCachedWalletState } from "./updateCachedWalletState";

export const reSyncWallets = async (
  accountId: string,
  wallets: WalletToSync[],
): Promise<void> => {
  const walletIds = wallets.map((w) => w._id);

  updateCachedWalletState(accountId, walletIds, {
    syncState: SyncState.InProgress,
  });

  const name =
    wallets.length === 1 ?
      getWalletName({ wallet: wallets[0], dataSource: wallets[0].dataSource })
    : "Data Sources";

  const toast = createStandaloneToast({ theme });
  toast({
    status: "info",
    title: `Started syncing ${name}`,
    duration: secondsToMilliseconds(3),
    isClosable: true,
  });

  try {
    const response = await reSyncWalletRequest(accountId, walletIds);

    checkStatusAndDoPendingWork();

    if (response.failed.length === 0) {
      toast(buildSyncSuccessToastProps(wallets));
    } else {
      toast(buildSyncErrorToastProps(response));
    }
  } catch (error) {
    // this is not caused by any of the syncs failing, it's because of an
    // error in the resync request.
    toast(errorToToastOptions(error));
  } finally {
    queryClient.invalidateQueries([
      ...getAccountTransactionsCacheKey(accountId),
    ]);
    queryClient.invalidateQueries(getAllAssetsCacheKey());
  }
};
